import { Experiment, Result } from '@growthbook/growthbook-react';

type GrowtBookData = Map<
	string,
	{
		experiment: Experiment<any>;
		result: Result<any>;
	}
>;

const getInfoByExperiment = (
	growthbookData: GrowtBookData,
	experiment: string,
) => {
	const growthData = {
		experimentName: '',
		experimentValue: '',
	};

	growthbookData.forEach((info) => {
		if (info.result.featureId === experiment) {
			growthData.experimentName = info.experiment.key;
			growthData.experimentValue = info.result.key;
		}
	});

	return growthData;
};

const GROWTHBOOK_FEATURE_FLAGS = {
	HIDE_CLOSE_ONBOARDING: 'hide_close_onboarding',
	SHOW_SAMANTHA: 'show_samantha',
	SAT_IS_DOWN: 'sat_is_down',
	SHOW_ERROR_SAT_ALERT: 'show_error_SAT_alert',
	SHOW_ORGANIZATIONS: 'show_organizations',
	REFERRAL_PRICE: 'referral_price_test',
	GET_PRICE_ELASTICITY: 'price_elasticity',
};

export default GROWTHBOOK_FEATURE_FLAGS;

export { getInfoByExperiment };
